/**
 * 家具(株式会社リーヴオン)商品とその他商品のカート混在を防ぐ追加時ガード。
 * 入口: 商品ページのカート追加フォーム / お気に入り・共有ページの [data-wishlist-atc]。
 * 競合時は確認モーダルを出し、OKなら /cart/clear.js でカートを空にしてから追加を続行する。
 * ※カート永久リンク等の裏口は防げないため、カート/ドロワー側のチェックアウト時ガードが保険。
 */
(function () {
  'use strict';

  var FURNITURE_VENDOR = '株式会社リーヴオン';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function showConfirmModal() {
    return new Promise(function (resolve) {
      var overlay = document.createElement('div');
      overlay.className = 'vendor-guard-modal';
      overlay.innerHTML =
        '<div class="vendor-guard-modal__box" role="alertdialog" aria-modal="true" aria-labelledby="vendor-guard-modal-text">' +
        '<button type="button" class="vendor-guard-modal__close" aria-label="閉じる"></button>' +
        '<p class="vendor-guard-modal__alert">カートへ追加する前にご確認ください</p>' +
        '<p id="vendor-guard-modal-text" class="vendor-guard-modal__text">家具とその他の商品は同時にご購入いただけません。<br>カートを空にしてこの商品を追加しますか？</p>' +
        '<div class="vendor-guard-modal__actions">' +
        '<button type="button" class="vendor-guard-modal__ok">カートを空にして追加</button>' +
        '<button type="button" class="vendor-guard-modal__cancel">キャンセル</button>' +
        '</div>' +
        '</div>';

      function close(result) {
        overlay.remove();
        document.removeEventListener('keydown', onKeydown);
        resolve(result);
      }
      function onKeydown(e) {
        if (e.key === 'Escape') close(false);
      }

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close(false);
      });
      overlay.querySelector('.vendor-guard-modal__close').addEventListener('click', function () {
        close(false);
      });
      overlay.querySelector('.vendor-guard-modal__ok').addEventListener('click', function () {
        close(true);
      });
      var cancelBtn = overlay.querySelector('.vendor-guard-modal__cancel');
      cancelBtn.addEventListener('click', function () {
        close(false);
      });
      document.addEventListener('keydown', onKeydown);

      document.body.appendChild(overlay);
      cancelBtn.focus();
    });
  }

  // 追加してよければ true を返す（競合時は確認→OKでカートを空にして true）
  function ensureAddable(vendor) {
    return fetch(root + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        if (items.length === 0) return true;

        var addingFurniture = vendor === FURNITURE_VENDOR;
        var conflict = items.some(function (item) {
          var itemIsFurniture = item.vendor === FURNITURE_VENDOR;
          return addingFurniture ? !itemIsFurniture : itemIsFurniture;
        });
        if (!conflict) return true;

        return showConfirmModal().then(function (ok) {
          if (!ok) return false;
          return fetch(root + 'cart/clear.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          }).then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            return true;
          });
        });
      })
      .catch(function () {
        // カート取得に失敗した場合は購入導線を止めない
        return true;
      });
  }

  // 商品ページ: カート追加フォームの submit に capture で割り込む
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      if (form.dataset.vendorGuardOk === 'true') {
        delete form.dataset.vendorGuardOk;
        return;
      }

      // form.id は <input name="id">(バリアントID)にシャドーイングされるため getAttribute で取る
      var formId = form.getAttribute('id');
      var buyButtons = formId ? document.querySelector('buy-buttons[form="' + formId + '"]') : null;
      var vendor = buyButtons && buyButtons.dataset.vendor;
      if (!vendor) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      var submitter = e.submitter;

      ensureAddable(vendor).then(function (ok) {
        if (!ok) return;
        form.dataset.vendorGuardOk = 'true';
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(submitter || undefined);
        } else {
          form.submit();
        }
      });
    },
    true
  );

  // お気に入り/共有ページ: [data-wishlist-atc] クリックに capture で割り込む
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('[data-wishlist-atc][data-vendor]');
      if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;

      if (btn.dataset.vendorGuardOk === 'true') {
        delete btn.dataset.vendorGuardOk;
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      ensureAddable(btn.dataset.vendor).then(function (ok) {
        if (!ok) return;
        btn.dataset.vendorGuardOk = 'true';
        btn.click();
      });
    },
    true
  );
})();
